
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { METHOD_TYPES } from 'utils/constants/index'

export const placeBet = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/penalty-shoot-out/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getPreviousRoundState = () => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/penalty-shoot-out/unfinished-bet-state', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const KickCount = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/penalty-shoot-out/penalty-kick', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const cashOutBet = () => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/penalty-shoot-out/cash-out-bet', {}, {
    server: microServices.SERVICE_URL_1
  })
}
